// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseConditionStatus = {
  ConditionStatusTrue: 'True',
  ConditionStatusFalse: 'False',
  ConditionStatusUnknown: 'Unknown',
} as const;
export type ResponseConditionStatus =
  (typeof ResponseConditionStatus)[keyof typeof ResponseConditionStatus];

export function instanceOfResponseConditionStatus(value: any): boolean {
  for (const key in ResponseConditionStatus) {
    if (Object.prototype.hasOwnProperty.call(ResponseConditionStatus, key)) {
      if (
        ResponseConditionStatus[key as keyof typeof ResponseConditionStatus] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseConditionStatusFromJSON(
  json: any,
): ResponseConditionStatus {
  return ResponseConditionStatusFromJSONTyped(json, false);
}

export function ResponseConditionStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseConditionStatus {
  return json as ResponseConditionStatus;
}

export function ResponseConditionStatusToJSON(
  value?: ResponseConditionStatus | null,
): any {
  return value as any;
}

export function ResponseConditionStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseConditionStatus {
  return value as ResponseConditionStatus;
}
